import { useQuery } from '@apollo/client';
import { LIST_CANDIDATES_QUERY } from '../queries/candidateQueries';

export const useCandidatesList = (companyId, pageNumber = 1, pageSize = 10, searchQuery = '') => {
  const { loading, error, data, refetch } = useQuery(LIST_CANDIDATES_QUERY, {
    variables: { 
      companyId,
      pageNumber,
      pageSize,
      query: searchQuery || ''
    },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
    skip: !companyId
  });

  const candidates = data?.listCandidates?.items || [];
  const totalCount = data?.listCandidates?.totalCount || 0;
  const pageCount = Math.ceil(totalCount / pageSize);

  return {
    loading,
    error,
    candidates,
    totalCount,
    pageCount,
    refetch
  };
};